<template>
    <v-row>
        <v-col v-if="!isLogged" cols="12" class="d-flex justify-end profile-buttons py-0">
            <v-btn
                large
                class="create-my-account-btn rounded-pill font-weight-bold mx-md-2 my-1"
                :loading="loadingAuth"
                @click="register"
            >
                {{ $t('header.profile.createMyAccount') }}
            </v-btn>
            <v-btn
                large
                class="button-secondary-color rounded-pill font-weight-bold mx-md-2 my-1"
                :loading="loadingAuth"
                @click="login"
            >
                {{ $t('header.profile.loginText') }}
            </v-btn>
        </v-col>
        <v-col v-else cols="12" class="d-flex text-center profile-buttons connected justify-end py-0">
            <v-btn
                large
                class="create-my-account-btn rounded-pill font-weight-bold mx-md-2 py-0"
                :loading="loadingAuth"
                :href="`${getProfileUrl}/dashboard?locale=${getLocale}`"
                target="_blank"
            >
                <v-icon
                    class="mr-2"
                    color="white"
                    :dense="$vuetify.breakpoint.lgAndUp"
                    :small="$vuetify.breakpoint.md">
                    fa-solid fa-user
                </v-icon>
                {{ $t('header.profile.loggedText') }}
            </v-btn>
            <v-btn
                large
                class="button-secondary-color rounded-pill font-weight-bold mx-md-2 logout py-0"
                :loading="loadingAuth"
                @click="showLogoutConfirmationModal"
            >
                <v-icon
                    class="mr-2"
                    color="black"
                    :dense="$vuetify.breakpoint.lgAndUp"
                    :small="$vuetify.breakpoint.md"
                >
                    fas fa-sign-out-alt
                </v-icon>
                {{ $t('header.profile.menu.disconnect') }}
            </v-btn>
        </v-col>
        <logout-confirmation-modal />
    </v-row>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import LogoutConfirmationModal from '@/components/bars/logoutConfirmationModal/LogoutConfirmationModal';
import { authModule, isUsingKc } from '@/utils';

export default {
    name: 'standard-login-button',
    components: {
        LogoutConfirmationModal,
    },
    computed: {
        ...mapGetters({
            getLoggedUser: `${authModule}/getLoggedUser`,
            getOwnerPatient: `${authModule}/getOwnerPatient`,
            getProfileUrl: `${authModule}/getProfileUrl`,
            loadingAuth: `${authModule}/getLoading`,
            getLocale: 'locale',
            getEstablishmentId: 'establishment/getEstablishmentId',
        }),

        isLogged() {
            if (isUsingKc) {
                return !!this.getLoggedUser;
            }
            return !!this.getLoggedUser && this.getOwnerPatient.uuid;
        },
    },
    methods: {
        ...mapActions({
            openSignInWindow: 'jwt/openSignInWindow',
            openRegisterWindow: 'jwt/openRegisterWindow',
            openKcSignInWindow: 'kcLogin/openSignInWindow',
            openKcRegisterWindow: 'kcLogin/openRegisterWindow',
        }),

        ...mapMutations({
            setOpenLogoutConfirmationDialog: 'jwt/SET_LOGOUT_CONFIRMATION_MODAL',
        }),

        async login() {
            if (isUsingKc) {
                return this.openKcSignInWindow();
            }
            return this.openSignInWindow(false);
        },

        async register() {
            if (isUsingKc) {
                return this.openKcRegisterWindow();
            }
            return this.openRegisterWindow({
                clientDataForUrl: { locale: this.getLocale },
            });
        },

        showLogoutConfirmationModal() {
            this.setOpenLogoutConfirmationDialog(true);
        },
    },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables';

.create-my-account-btn::v-deep {
    background-color: $cs-color-secondary !important;
    color: white !important;
}

.create-my-account-btn:before {
    background-color: $cs-color-secondary !important;
}

.profile-buttons::v-deep {
    position: relative;
    @media only screen and (max-width: 1386px) {
        .v-btn {
            width: 200px!important;
            font-size: 0.85rem!important;
        }
    }
    @media only screen and (max-width: 1301px) {
        .v-btn {
            width: 195px !important;
            font-size: 0.9rem!important;
        }
    }
    @media only screen and (max-width: 1264px) {
        .v-btn {
            width: 175px!important;
            font-size: 0.75rem!important;
        }
    }
    @media only screen and (max-width: 1024px) {
        .v-btn {
            width: 155px!important;
            font-size: 0.65rem!important;
        }
    }
    @media only screen and (max-width: 959px) {
        flex-direction: column;
        .v-btn {
            font-size: 1rem!important;
            width: 70%!important;
            margin: 10px 15%!important;
        }
    }

    button.v-btn {
        margin: 0;
    }
}

.v-btn.button-secondary-color {
    color: black!important;
}

.logo {
    top: -20px;
    position: relative;
    width: 100%;
    min-width: 175px;
    max-width: 155px;
    filter: drop-shadow(0px 3px 6px #00000029);
    @media only screen and (max-width: 1246px) {
        max-width: 80px;
        min-width: 80px;
        top: 5px;
    }
}
</style>
